import { useEffect, useState } from 'react';

// False during the server render and the hydration pass, true from the first
// effect on. Markup that depends on the device, storage, or the resolved theme
// waits for it, so the first client render matches the prerendered HTML.
export default function useHydrated() {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  return hydrated;
}
